export default __webpack_public_path__ + "static/media/virgool.18d90682.svg";